export const ALPHA_TOKEN_CHARS_STR = 'abcdefghijklmnopqrstuvwxyz';
export const DIGIT_TOKEN_CHARS_STR = '0123456789';
const ALL_TOKEN_CHARS_STR = `${ALPHA_TOKEN_CHARS_STR}${DIGIT_TOKEN_CHARS_STR}`;
export function getRandomToken(length = 12, tokenCharsStr = ALL_TOKEN_CHARS_STR) {
    let randomToken = '';
    while (randomToken.length < length) {
        randomToken += tokenCharsStr[Math.floor(secureRandom() * tokenCharsStr.length)];
    }
    return randomToken;
}
/**
 * Returns a random number [0, 1) (excludes 1).
 * This is analogous to Math.random().
 */
export function secureRandom() {
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);
    return array[0] / (0xffffffff + 1);
}
